<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <img src="../../assets/shatter_logo.png" width="100%" alt="">
            </v-flex>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs12>
                <app-title>Ubicación</app-title>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3982.6399825044564!2d-76.54035428489344!3d3.4374639522702815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e30a68592fe1df7%3A0x982ce11a688e2671!2sShatter+Seguridad!5e0!3m2!1sen!2sco!4v1542660832689" width="350" height="350" frameborder="0" style="border:0" allowfullscreen></iframe>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-list subheader three-line>
                    <v-subheader>Información General</v-subheader>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Direcciones</v-list-tile-title>
                            <v-list-tile-sub-title v-for="(address, i) in shatterInfo.addresses" :key="i"> {{address.city}}, {{address.country}}: {{address.address}}</v-list-tile-sub-title> 
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Sitio Web</v-list-tile-title>
                            <v-list-tile-sub-title><a :href="shatterInfo.website">{{ shatterInfo.website }}</a></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Teléfonos</v-list-tile-title>
                            <v-list-tile-sub-title>
                                <v-layout row wrap>
                                    <v-flex xs12 v-for="phone in shatterInfo.phones" :key="phone.value">{{ phone.label }}: {{ phone.value }}</v-flex>
                                </v-layout>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>E-mails</v-list-tile-title>
                            <v-list-tile-sub-title>
                                <v-layout row wrap>
                                    <v-flex xs12 v-for="email in shatterInfo.emails" :key="email.value">{{ email.label }}: <a :href="'mailto:' + email.value">{{ email.value }}</a></v-flex>
                                </v-layout>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import shatterInfo from './shatterinfo.json';
export default {
    name: 'About',
    data() {
        return {
            shatterInfo: null
        }
    },
    methods: {
        loadShatterInfo() {
            // $.getJSON('shatterinfo.json', function(data) {
            //     this.shatterInfo = data;
            // });
            this.shatterInfo = shatterInfo;
        }
    },
    created() {
        this.loadShatterInfo();
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Shatter/Shatter.vue